<panel width="650">
  @if (loadingData || loadingProduct) {
    <skeletons [customSkeletons]="[['1em', '50%', 'h1']]" [defaultSkeletons]="5" />
  }

  @if (!loadingData && !loadingProduct) {
    <h1>{{ productName ? productName : 'product.create' | translate }}</h1>
  }
  @if (product && !loadingData && !loadingProduct) {
    <section one-column scrollable>
      <tags [(selectedTags)]="product.productTags" [tags]="productTags" />
      <custom-input [label]="'product.name' | translate" [inputType]="inputTypeEnum.Text" [(value)]="product.name" />
      <custom-input [label]="'product.active' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="product.active" />
      <custom-input [label]="'product.commission-disabled' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="product.commissionDisabled" />
      <custom-select [label]="'product.accounting-plan-setup' | translate" [required]="true" [selectList]="accountingPlanSetups" [(value)]="product.accountingPlanSetupId" />
      <custom-input [label]="'product.allowed-discount' | translate" [inputType]="inputTypeEnum.Number" [(value)]="product.allowedDiscount" />
      <custom-input [label]="'product.quarterly-period-price-increase-percent' | translate" [inputType]="inputTypeEnum.Percentage" [(value)]="product.quaterlyPeriodPriceIncreasePercent" />
      <custom-input [label]="'product.yearly-period-price-increase-percent' | translate" [inputType]="inputTypeEnum.Percentage" [(value)]="product.yearlyPeriodPriceIncreasePercent" />
      <custom-input [label]="'product.creation-fee' | translate" [inputType]="inputTypeEnum.Number" [(value)]="product.creationFee" />
      <custom-input [label]="'product.auto-renew' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="product.autoRenew" />
      <custom-input [label]="'product.group-on-order' | translate" [inputType]="inputTypeEnum.Switch" [(value)]="product.groupByVariantAndParentOnOrder" />
      <custom-select [label]="'product.required-product' | translate" [selectList]="otherProducts" [(value)]="product.requiredProductId" />
      <custom-input [label]="'product.description' | translate" [inputType]="inputTypeEnum.Textarea" [(value)]="product.description" />
      <custom-input [label]="'product.terms' | translate" [inputType]="inputTypeEnum.Editor" [(value)]="product.terms" />
    </section>
  }
  @if (newProduct) {
    <section>
      <button #saveButton confirm [asyncCallback]="createProduct" [label]="'general.create' | translate"></button>
    </section>
  }
  @if (!newProduct) {
    <section>
      <button #saveButton confirm [asyncCallback]="saveProduct" [label]="'general.save' | translate"></button>
      <button #deleteButton reject [asyncCallback]="deleteProduct" [ignoreValidation]="true" [label]="'general.delete' | translate"></button>
    </section>
  }
</panel>
@if (!newProduct) {
  <panel width="600">
    <h1>{{ 'product.variants' | translate }}</h1>
    @if (loadingData) {
      <skeletons [customSkeletons]="[['2em', '100%']]" [defaultSkeletons]="5" />
    }
    @if (!loadingData && product) {
      <section>
        <button small [loader]="false" [ignoreValidation]="true" (click)="openVariantOptionSelection()">{{ 'product.variants.change-variant-options' | translate }}</button>
      </section>
      <section scrollable (scroll)="scrolledVariants()" #variantContainer>
        @for (variant of visibleVariants; track variant) {
          <div>{{ productService.getVariantName(variant, false, true) }}</div>
          <div align-right><input type="text" [ngModel]="getCurrency(variant)" [customValidState]="variant.displayPrice.isValidPrice()" (ngModelChange)="setCurrency(variant, $event)" align-right /></div>
        }
      </section>
    }
  </panel>
}
@if (newProduct) {
  <select-variant-options #newProductVariantOptions [variantLists]="variantLists" />
}
